<template>
  <div class="floating-block" :class="className" :style="timeWrapperStyle">
    <div :class="{fixed: fixed}" :style="absoluteStyles">
      <slot/>
    </div>
  </div>
</template>
<script>

  import {calculate_window_cont} from '@/_helpers/utils'

  export default {
    name: 'floating-block',
    data () {
      return {
        pageYOffset: null,
        fixed: false,
        relativeParent: null
      }
    },
    props: {
      className: {
        type: String,
        default: null
      }
    },
    computed: {

      absoluteStyles () {
        if (!this.fixed) return {};
        return {
          position: 'absolute',
          left: 0,
          right: 0,
          top: `${this.pageYOffset - calculate_window_cont(this.relativeParent).y}px`
        }
      },
      timeWrapperStyle () {
        if (!this.fixed) return null
        return {
          height: `${this.$el.children[0].offsetHeight}px`
        }
      }
    },
    methods: {
      scrollListener () {
        const oldFixed = this.fixed;
        this.pageYOffset = window.pageYOffset;
        this.fixed = this.$el.getBoundingClientRect().top <= 0;
        if (oldFixed !== this.fixed) this.$emit('changeFixed', this.fixed);
      },
      setRelativeParent () {
        let parent = this.$el;
        while (parent && !~['relative', 'absolute', 'fixed'].indexOf(getComputedStyle(parent).position)) {
          parent = parent.parentNode;
        }
        this.relativeParent = parent;
      }
    },
    mounted () {
      this.setRelativeParent();
      this.scrollListener();
      window.addEventListener('scroll', this.scrollListener, false)
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.scrollListener, false)
    }
  }
</script>
<style lang="scss" scoped="">
  .floating-block {
    &.timer {
      margin: 10px 0;
      > div{
        background: white;
        z-index: 5;
        &.fixed {
          padding: 0 156px;
          box-shadow: 0 1px 40px rgba(28, 50, 75, 0.05);
        }
      }
    }
  }
</style>